<template>
  <div class="top-contianer">
    <!-- <div class="main_header">
      <h3 style="color: #00264a;"></h3>
      <div class="carousel_container">
        <div class="containerr">
          <b-img-lazy :src="mainHeadlines[0].img" alt style="width:100%; border-radius: 20px;"></b-img-lazy>
          <h5 class="centered">{{mainHeadlines[0].description}}</h5>
        </div>
      </div>
    </div>
    <div class="grey_strip"></div>-->
    <!-- <a href="#" class="sloganBtn"></a> -->
    <div class="video-container">
      <div class="mid-screen-text centered">
        <div class="who-we-are">Vortex Robotics</div>
        <div class="what-we-do">The first ROV Manufacturer in the Middle East</div>
        <div style="text-align: center; width: 100%;">
          <b-button
            class="contact-us-home-button"
            pill
            variant="outline-secondary"
            @click="setActive(7); $router.push('contact_us');"
          >Contact us 📞</b-button>
        </div>
        <div class="bounce">
          <a href="#what-we-do">
            <span class="down-arrow">&raquo;</span>
          </a>
        </div>
      </div>

      <video autoplay muted loop class="home-video" poster="../../public/vid/posters/vdrax.png">
        <source src="../../public/vid/vdrax_home.mp4" type="video/mp4" />
      </video>
    </div>

    <GearsSep />
    <br />
    <br />
    <div id="what-we-do" class="eliptical-gray">
      <h2 class="back-text">Our Services</h2>
      <h3 style="font-weight: bold;">What we do</h3>
      <div class="breaker"></div>
      <br />
      <br />
      <br />
      <div style="display: inline-block; width: 80%;">
        <div class="what-we-do-cards" v-for="action in whatWeDo" :key="action.id">
          <b-img-lazy class="what-we-do-icon" :src="action.icon" :alt="action.name"></b-img-lazy>
          <div class="header">{{action.name}}</div>
          <div class="description">{{action.description}}</div>
        </div>
      </div>
    </div>
    <br />
    <b-container class="large-hexa-container">
      <b-row>
        <b-col style="margin:auto;">
          <h2
            style="color: #00264a;"
          >We succeeded to be the first ROV Manufacturer in the Middle East, developing ROVs available for rent and sell.</h2>
        </b-col>
        <b-col>
          <div style="margin-left: 10%;" class="hexagon hexagon2">
            <div class="hexagon-in1">
              <div class="hexagon-in2 hexagon-image-first-rov"></div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="shift-up">
        <b-col>
          <div style="margin-left: -50%;" class="hexagon hexagon2">
            <div class="hexagon-in1">
              <div class="hexagon-in2 hexagon-image-crew"></div>
            </div>
          </div>
        </b-col>
        <b-col style="margin:auto;">
          <h2
            style="color: #00264a;"
          >We have a very experienced, motivated and well trained crew available at your service up on request to make your offshore tasks easier.</h2>
        </b-col>
      </b-row>
      <b-row class="shift-up">
        <b-col style="margin:auto;">
          <h2
            style="color: #00264a;"
          >We spread our knowledge through our academic department and we've got the lead in all the region ROV competitions.</h2>
        </b-col>
        <b-col>
          <div style="margin-left: 10%;" class="hexagon hexagon2">
            <div class="hexagon-in1">
              <div class="hexagon-in2 hexagon-image-academic"></div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <br />
    <br />
    <br />
    <div class="main eliptical-gray">
      <div class="main-topics-container">
        <div class="myBtnContainer" id="myBtnContainer">
          <h4 class="back-text">OUR BLOG</h4>
          <h3 style="font-weight: bold;">Latest News</h3>
          <div class="breaker" style="margin-bottom: 60px;"></div>
          <b-button
            v-for="category in newsCategories"
            :key="category.id"
            :class="'btn ' + category.active"
            @click="filterSelection(category.name)"
          >{{category.name}}</b-button>
        </div>

        <div class="row">
          <div v-for="topic in mainTopics" :key="topic.id" :class="'newsColumn ' + topic.category">
            <div class="newsContent">
              <div class="newsImageContainer">
                <b-img-lazy
                  :src="topic.picture"
                  class="newsImage"
                  alt="News Image"
                  style="width:100%"
                ></b-img-lazy>
              </div>
              <h4 class="mt-4">{{topic.title}}</h4>
              <h5 class="date">{{topic.date}}</h5>
              <hr />
              <p>{{topic.description}}</p>
              <a
                style="color: #00264a; text-decoration:underline;"
                :href="topic.link"
                target="_blank"
                variant="outline-secondary"
              >Read More</a>
              <b-button
                class="apply-now-btn"
                v-if="topic.applyNow"
                v-b-modal=" 'applyNow' + topic.id"
                variant="success"
                disabled
              >Apply Now</b-button>
              <b-modal
                v-if="topic.applyNow"
                :id=" 'applyNow' + topic.id"
                size="lg"
                :title=" 'Apply to ' + topic.title"
              >Hello Large 2!</b-modal>
            </div>
          </div>
        </div>

        <b-alert :show="noNews" variant="warning">Choose filter from above to show relevant news.</b-alert>
        <br />
      </div>
    </div>
    <div style="width: 100%; height: 150px;"></div>

    <div style="text-align: center; width: 100%; color: #00264a;">
      <h2 class="back-text">Wall Of Fame</h2>
      <h3 style="font-weight: bold;">Partners & Sponsors</h3>
      <div class="breaker"></div>
      <br />
      <div style="display: inline-block; width: 84.22%;">
        <div class="sponsor-logo" v-for="sponsor in sponsors" :key="sponsor.id">
          <b-img-lazy class="sponsor-logo-img" :src="sponsor.logo"></b-img-lazy>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GearsSep from "./../components/GearsSep.vue";

export default {
  components: {
    GearsSep
  },
  data() {
    return {
      noNews: true,
      j: 0,
      slide: 0,
      sliding: null,
      whatWeDo: [
        {
          id: 0,
          icon: "img/icons/what_we_do/i_rov.png",
          name: "Observation ROVs",
          description:
            "We are the first ROV Manufacturer in the Middle East, our ROVs are available for rent up on request."
        },
        {
          id: 3,
          icon: "img/icons/what_we_do/offshore.png",
          name: "Offshore Services",
          description:
            "Our Crew can offer offshore services using our ROVs such as Tank Inspection, Underwater filming & seabed exploration."
        },
        {
          id: 1,
          icon: "img/icons/what_we_do/auv.png",
          name: "AUVs",
          description:
            "We are the first Autonomous ROV (AUV) Manufacturer in the Middle East, our AUVs are available for rent up on request."
        },
        {
          id: 4,
          icon: "img/icons/what_we_do/courses.png",
          name: "Academic Courses",
          description:
            "With our Technical Instructors, We offer all levels of robotics and ROVs educational courses from beginner levels to advanced."
        },
        {
          id: 2,
          icon: "img/icons/what_we_do/m_rov.png",
          name: "Mini ROVs (Sell/Rent)",
          description:
            "We sell, rent or even design mini class ROVs that can be used for educational, exploring and filming purposes."
        },

        {
          id: 5,
          icon: "img/icons/what_we_do/competitions.png",
          name: "Competitions",
          description:
            "We participate in many regional and international ROVs competitions using our well-trained students from Vortex academy."
        },
        {
          id: 6,
          icon: "img/icons/what_we_do/store.png",
          name: "Vortex Store",
          description:
            "Vortex store contains all Robotics & ROV related components, some of the products that we sell are manufactured by Vortex."
        },
        {
          id: 7,
          icon: "img/icons/what_we_do/workshop.png",
          name: "Vortex Workshop",
          description:
            "Vortex has a fully equipped workshop that people can use for their own purpose, also we provide different manufacturing services."
        }
      ],
      newsCategories: [
        { id: 0, name: "Show All" },
        { id: 1, name: "Academy" },
        { id: 2, name: "Commercial" },
        { id: 3, name: "Business" },
        { id: 4, name: "General News" },
        { id: 5, name: "Events" },
        { id: 6, name: "Hide All" }
      ],
      sponsors: [
        {
          id: 0,
          name: "Arab Academy For Science and Technology",
          logo: "img/logos/sponsors/aast.jpeg"
        },
        {
          id: 1,
          name: "Prometheus Solutions",
          logo: "img/logos/sponsors/prometheus.png"
        },
        {
          id: 2,
          name: "SeaSplit",
          logo: "img/logos/sponsors/sea-split.jpeg"
        },
        {
          id: 3,
          name: "Ministry Of Education, UAE",
          logo: "img/logos/sponsors/moe_uae.png"
        },
        {
          id: 4,
          name: "Soyven",
          logo: "img/logos/sponsors/soyven.jpg"
        },
        {
          id: 5,
          name: "Blue Robotics",
          logo: "img/logos/sponsors/blue-robotics.png"
        },
        {
          id: 6,
          name: "Silicon waha",
          logo: "img/logos/sponsors/silicon-waha.jpg"
        },
        {
          id: 7,
          name: "Global Innovation through Science and Technology (GIST)",
          logo: "img/logos/sponsors/gist.jpg"
        }
      ],
      mainHeadlines: [
        {
          id: 0,
          img: "img/news/first_milestone.jpeg",
          title: "First Milestone",
          description:
            "We have reached an important milestone and achieved a new momentum in reaching a goal we all should embrace. No matter what industry you work in, hard work and team spirit is the recipe for a burgeoning and successful business. More details soon 🌪"
        }
      ],
      mainHeaders: [
        { id: 0, path: "img/carousel/history.jpg", to: "/about_us" },
        { id: 1, path: "img/carousel/robosub.jpg", to: "/academy" },
        { id: 2, path: "img/carousel/slider1.jpg", to: "/commercial" },
        { id: 3, path: "img/carousel/slider2.jpg", to: "/academy" },
        { id: 4, path: "img/carousel/slider3.jpg", to: "/store" }
      ],
      mainTopics: [
        {
          id: 11,
          picture: "img/news/robosub.png",
          date: "1/6/2021",
          title: "Vortex in Robosub",
          link: "/auv",
          category: "General News",
          description:
            "Vortex is participating in Robosub International AUV competition remoteley in 2021."
        },
        {
          id: 0,
          picture: "img/news/loghat_al_asr.jpg",
          date: "1/4/2021",
          title: "Al Ahram مجلة لغة العصر",
          link:
            "https://www.facebook.com/342375502520843/posts/3842648799160145/?d=n",
          category: "General News",
          description:
            "أعلنت شركة فورتكس عن نجاح تجربة أول غواصة آلية ذات تحكم عن بعد في الرالى الخامس لريادة الأعمال الذى انعقد يومى 28 و 29 مارس بمدينة شرم الشيخ، والذى نظمته الأكاديمية العربية للعلوم والتكنولوجيا والنقل البحري بحضور د. إسماعيل عبد الغفار، رئيس الأكاديمية."
        },
        {
          id: 1,
          picture: "img/news/pitching.jpg",
          date: "28/3/2021",
          title: "Startup Festival Pitch Deck",
          link: "https://fb.watch/57CgsG2FF1/",
          category: "Business",
          description:
            "Our announcement for the 1st Commercial ROV made in Egypt and the Middle East in the Startups Festival by the Arab Academy for Science and Technology and Maritime Transport after testing in the Mediterranean Sea."
        },
        {
          id: 2,
          picture: "img/news/prometheus.jpg",
          date: "22/1/2021",
          title: "Partnership with Prometheus Solutions in Gulf Region",
          link:
            "https://www.facebook.com/vortexroboticsegypt/photos/a.1030975760311704/3526964377379484/",
          category: "Business",
          description:
            "We were honored to announce a partnership with Prometheus Solutions Represented by her CEO Anneliese . It's a great opportunity to expand our work in the UAE."
        },
        {
          id: 3,
          picture: "img/news/elpais.jpg",
          date: "22/11/2020",
          title: "El Pais Spanish News Platform",
          link:
            "https://elpais.com/internacional/2020/11/22/mundo_global/1606030602_858060.html",
          category: "Community",
          description:
            "We were mentioned in El Pais Spanish News platform concerning our coverage for the longest dive in history by Saddam Kilany."
        },
        {
          id: 4,
          picture: "img/news/longest_dive.jpg",
          date: "15/11/2020",
          title: "The Longest Dive in History",
          link:
            "https://www.facebook.com/vortexroboticsegypt/photos/a.938753606200587/3353884981354092/",
          category: "Community",
          description:
            "As sea enthusiasts, we can't leave Dahab without a dive in Dahab. From the spot of Saddam's six days of glory, we were honored to raise our flag celebrating our achievement and happiness of participation in The Longest Dive In History."
        },
        {
          id: 5,
          picture: "img/news/sea_split.jpg",
          date: "25/9/2020",
          title: "First Commercial AUV contract with SeaSplit",
          link:
            "https://www.facebook.com/vortexroboticsegypt/photos/a.938753606200587/3353884981354092/",
          category: "Business",
          description:
            "We were honored to sign the contract for the design, development and manufacturing of Egypt's first AUV with SeaSplit company by the field expert Eng. Hussein Mesharafa and leadership of Eng. Aya Hallouda CEO SeaSplit."
        },
        {
          id: 6,
          picture: "img/news/keep_the_date.jpg",
          date: "31/3/2021",
          title: "Save the date!",
          category: "Commercial",
          description:
            "Do the one thing you think you cannot do. Fail at it. Try again. Do better the second time. The only people who never tumble are those who never mount the high wire. This is our moment. We own it."
        },
        {
          id: 7,
          picture: "img/news/first_milestone.jpeg",
          date: "30/3/2021",
          title: "First Milestone!",
          category: "Commercial",
          description:
            "We have reached an important milestone and achieved a new momentum in reaching a goal we all should embrace. More details soon 🌪"
        },
        {
          id: 8,
          picture: "img/news/stay_tuned.jpg",
          date: "29/3/2021",
          title: "Stay Tuned!",
          category: "Commercial",
          description: "We are cooking something big. Can you guess it😉 ??"
        },
        {
          id: 9,
          applyNow: 0,
          picture: "img/news/we_r_back.gif",
          date: "20/8/2020",
          title: "Vortex is back!",
          category: "General News",
          description:
            "After the quarantine, Vortex is back even stronger and it's academy is the effective way to track your goals"
        },

        {
          id: 10,
          applyNow: 0,
          picture: "img/news/vdrax_1.jpg",
          date: "23/7/2019",
          title: "V-DRAX IS BACK!",
          category: "Commercial",
          description:
            "After a long time of waiting .. Here's V-drax ! our first Product which is ready to break in the underwater inspection field in Egypt and Middle East"
        }
      ]
    };
  },
  mounted() {
    this.filterSelection("Hide All");
    document.getElementById("nav-collapse").style.backgroundColor =
      "rgb(0,0,0,0)";
    document.getElementById("n121").style.backgroundColor =
      "rgb(242, 242, 242, 0)";
    document.getElementById("n122").style.backgroundColor = "rgb(0,0,0,0)";
    document.getElementById("n123").style.backgroundColor = "rgb(0,0,0,0)";
    document.getElementById("n121").style.color = "rgb(0,0,0) !important";
    var tabs = document.getElementById("right_nav").querySelectorAll("a");
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.color = "white";
    }
    document
      .getElementById("vortexNameImage")
      .setAttribute("src", "img/logos/vortex_name2.png");
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    youClicked() {
      window.scrollBy(0, 900);
    },
    filterSelection(c) {
      var x, i;
      x = document.getElementsByClassName("newsColumn");
      if (c == "Show All") c = "";
      this.noNews = true;
      for (i = 0; i < x.length; i++) {
        this.w3RemoveClass(x[i], "show");
        if (x[i].className.indexOf(c) > -1) {
          this.w3AddClass(x[i], "show");
          this.noNews = false;
        }
      }
    },
    w3AddClass(element, name) {
      var i, arr1, arr2;
      arr1 = element.className.split(" ");
      arr2 = name.split(" ");
      for (i = 0; i < arr2.length; i++) {
        if (arr1.indexOf(arr2[i]) == -1) {
          element.className += " " + arr2[i];
        }
      }
    },
    w3RemoveClass(element, name) {
      var i, arr1, arr2;
      arr1 = element.className.split(" ");
      arr2 = name.split(" ");
      for (i = 0; i < arr2.length; i++) {
        while (arr1.indexOf(arr2[i]) > -1) {
          arr1.splice(arr1.indexOf(arr2[i]), 1);
        }
      }
      element.className = arr1.join(" ");
    },
    setActive(id) {
      document.documentElement.style.scrollBehavior = "auto";
      setTimeout(
        () => (document.documentElement.style.scrollBehavior = "smooth"),
        1000
      );
      document.getElementById("nav" + id).style.borderTop = "5px solid #00264A";
      var i;
      for (i = 2; i < 8; i++) {
        if ("nav" + i === "nav" + id) {
          continue;
        } else {
          document.getElementById("nav" + i).style.borderTop =
            "5px solid #dddddd";
        }
      }
      window.scrollTo(0, 0);
    }
  },
  name: "home"
};
</script>

<style lang="scss">
$size: 30px;
$accent: #f2f2f2;

.carousel_container {
  width: 90%;
  display: inline-block;
  /*padding-top: 80px;*/
  padding-bottom: 30px;
  opacity: 1;
  -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 2s; /* Firefox < 16 */
  -ms-animation: fadein 2s; /* Internet Explorer */
  -o-animation: fadein 2s; /* Opera < 12.1 */
  animation: fadein 2s;
}
.inlnblk {
  display: inline-block !important;
}
.info_img {
  border-radius: 50% !important;
}

.apply-now-btn {
  margin-left: 20px;
  width: 50%;
}

.main_carousel {
  width: 90%;
  display: inline-block;
  overflow: hidden;
  border-radius: 15px;
}
.lower-section,
.upper-section {
  display: flex;
  /*justify-content: center;*/
  align-items: center;
}
.upper-section {
  min-height: 50;
  width: 100%;
  background: #ffffff;
}

.info-img {
  border-radius: 15px !important;
}

.containerr {
  position: relative;
  text-align: center;
  color: white;
  width: 90%;
  margin: auto;
  overflow: hidden;
  // padding-top: 56.25%;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.mid-screen-text {
  z-index: 4;
}

.centered {
  text-align: justify;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.what-we-do {
  text-align: center;
  font-size: 40px;
  color: #fff;
  font-weight: 900;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  line-height: 40px;
  margin-top: 20px;
}

.who-we-are {
  text-align: center;
  font-size: 30px;
  color: #fff;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  line-height: 30px;
}

.timeline {
  position: relative;

  &::before {
    content: "";
    background: #f2f2f2;
    width: 5px;
    height: 95%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}

.timeline-item {
  width: 100%;
  margin-bottom: 70px;

  &:nth-child(even) {
    .timeline-content {
      float: right;
      padding: 40px 30px 10px 30px;

      .date {
        right: auto;
        left: 0;
      }

      &::after {
        content: "";
        position: absolute;
        border-style: solid;
        width: 0;
        height: 0;
        top: 30px;
        left: -15px;
        border-width: 10px 15px 10px 0;
        border-color: transparent #f5f5f5 transparent transparent;
      }
    }
  }

  &::after {
    content: "";
    display: block;
    clear: both;
  }
}

.timeline-content {
  position: relative;
  width: 45%;
  padding: 10px 30px;
  border-radius: 4px;
  background: #f5f5f5;
  box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.3);

  &::after {
    content: "";
    position: absolute;
    border-style: solid;
    width: 0;
    height: 0;
    top: 30px;
    right: -15px;
    border-width: 10px 0 10px 15px;
    border-color: transparent transparent transparent #f5f5f5;
  }
}
.lower-section {
  min-height: 50vh;
  width: 100%;
  background: #f2f2f2;
}
.section-divider {
  position: relative;
  padding-top: 20px;
}
.section-divider:before {
  font-family: "codepen";
  content: " ";
  width: 6.5rem;
  height: 6.5rem;
  background: #f2f2f2;
  border-radius: 100%;
  position: absolute;
  top: -3.25rem;
  left: calc(50% - 3.25rem);
  line-height: 6rem;
  text-indent: 1.75rem;
  font-size: 3rem;
}
.section-divider1 {
  position: relative;
  padding-bottom: 40px;
}
.section-divider1:before {
  font-family: "codepen";
  content: " ";
  width: 6.5rem;
  height: 6.5rem;
  background: #ffffff;
  border-radius: 100%;
  position: absolute;
  top: -3.25rem;
  left: calc(50% - 3.25rem);
  line-height: 6rem;
  text-indent: 1.75rem;
  font-size: 3rem;
}
#divider {
  position: relative;
  top: 0%;
  height: 10%;
  background: $accent;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -$size;
    height: $size;
    background-image: linear-gradient(45deg, transparent 75%, $accent 75%),
      linear-gradient(-45deg, transparent 75%, $accent 75%);
    background-position: center;
    background-size: $size $size;
  }
}
.gear {
}
.slogan_logo {
  width: 50px;
  height: 50px;
}
.grey_strip {
  background: #f2f2f2;
  width: 100%;
  height: 70px;
}
.left_slogan {
  text-align: left;
  transition: 0.7s ease-in-out;
  transform: translate(-140%, 0);
}
.right_slogan {
  text-align: right;
  transition: 0.7s ease-in-out;
  transform: translate(140%, 0);
}
.carousel-caption {
  bottom: 35% !important;
}
.goDown {
  overflow: hidden;
  width: 100%;
  max-height: 0px;
  margin-top: 70px;
  -webkit-transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
  -moz-transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
  -o-transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
  -ms-transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
  transition: max-height 1.5s ease-out, box-shadow 0.6s linear;
}
.grey {
  background: #f2f2f2;
}
.info-card {
  text-align: left;
  margin-left: 9%;
  margin-bottom: 5%;
  margin-top: 5%;
  max-width: 80%;
}
.card {
  border: none !important;
}
.flying_gear {
  z-index: 9999;
  background: url("../../public/img/logos/logo48g.png");
  width: 48px;
  height: 48px;
  position: fixed;
  right: 90px;
  top: 200px;
}
.fly_right_up {
  right: 10px;
  top: 200px;
}
.fly_right_down {
  right: 10px;
  top: 480px;
}
.fly_left_up {
  left: 10px;
  top: 250px;
}
.fly_left_down {
  left: 25px;
  top: 550px;
}
.carousel_padding {
  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1s;
  -webkit-transition: width 2.4s; /* For Safari 3.1 to 6.0 */
  transition: width 2.4s;
}
.white {
  width: 100%;
  height: 200px;
  background: #ffffff;
  overflow: hidden;
  z-index: 3;
  position: relative;
}
.bkg {
  /*background:#FFFFFF url(../../public/img/background2.png) center no-repeat;*/
  background: #ffffff;
  width: 100%;
  height: 182px;
}

/* Center website */
.main {
  max-width: 100%;
  margin: auto;
  background-color: #f1f1f1;
  padding: 20px;
}

.newsImageContainer {
  vertical-align: middle;
  min-width: 200px;
  max-width: 400px;
  // height: 350px;
  margin: auto;
  overflow: hidden;
}

.newsImage {
  max-width: 100%;
  max-height: 350px;
  border-radius: 10px;
  display: block;
}

h1 {
  font-size: 50px;
  word-break: break-all;
}

.row {
  margin: 8px -16px;
}

/* Add padding BETWEEN each column (if you want) */
.row,
.row > .newsColumn {
  padding: 8px;
}

/* Create three equal columns that floats next to each other */
.newsColumn {
  float: left;
  width: 33.33%;
  display: none; /* Hide columns by default */
}

.newsHeader {
  text-align: left;
  font-size: 200%;
  color: #00264a;
  font-weight: bolder;
}

/* Clear floats after rows */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Content */
.newsContent {
  background-color: white;
  border-radius: 10px;
  padding: 10px;
}

/* The "show" class is added to the filtered elements */
.show {
  display: block;
}

/* Style the buttons */
.myBtnContainer .btn {
  border: none;
  outline: none;
  padding: 12px 16px;
  margin-bottom: 8px;
  margin-right: 10px;
  background-color: white;
  font-weight: bold;
  color: #00264a;
  cursor: pointer;
}

/* Add a grey background color on mouse-over */
.myBtnContainer .btn:hover {
  background-color: #ddd;
  color: #00264a;
}

.date {
  color: darkgray;
  font-size: 100%;
}

/* Add a dark background color to the active button */
.btn.activeNews {
  background-color: #666;
  color: white;
}

.sloganBtn {
  display: inline-block;
  height: 50px;
  width: 50%;
  text-align: center;
  color: white;
  background: #f2f2f2;
  line-height: 50px;
  text-decoration: none;
  padding-bottom: 15%;
  background-clip: content-box;
  overflow: hidden;
}
.sloganBtn:after {
  content: "";
  position: absolute;
  top: 100px;
  left: -25%;
  background-color: inherit;
  padding-bottom: 75%;
  width: 150%;
  z-index: 0;

  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;

  -webkit-transform: rotate(-30deg) skewX(30deg);
  -ms-transform: rotate(-30deg) skewX(30deg);
  transform: rotate(-30deg) skewX(30deg);
}

.video-container {
  overflow: hidden;
  background-color: #1b4447;
  height: 100vh;
}

.home-video {
  left: 0%;
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: 1;
  opacity: 1;
  object-fit: cover;
  filter: brightness(0.3);
  -webkit-animation: fadein 2s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 2s; /* Firefox < 16 */
  -ms-animation: fadein 2s; /* Internet Explorer */
  -o-animation: fadein 2s; /* Opera < 12.1 */
  animation: fadein 2s;
}

:root {
  --triangleWidthNeg: -1400px;
  --triangleheightNeg: -200px;
  --triangleHeight: 200px;
  --triangleWidth: 1400px;
}

.video-container:after {
  content: "";
  position: absolute;
  -webkit-clip-path: polygon(100% 100%, 100% 0, 0 100%);
  clip-path: polygon(100% 100%, 100% 0, 0 100%);
  height: 25%;
  width: 51%;
  background-color: #fff;
  right: 0;
  bottom: -2px;
  z-index: 4;
}

.video-container:before {
  content: "";
  position: absolute;
  -webkit-clip-path: polygon(100% 100%, 0 0, 0 100%);
  clip-path: polygon(100% 100%, 0 0, 0 100%);
  height: 25%;
  width: 51%;
  background-color: #fff;
  left: 0;
  bottom: -2px;
  z-index: 4;
}

// .video-container:before {
//   content: "";
//   position: absolute;
//   bottom: 0px;
//   left: 0%;
//   margin-left: var(--triangleWidthNeg);
//   margin-top: var(--triangleheightNeg);
//   width: 0;
//   height: 0;
//   border-bottom: solid var(--triangleHeight) #fff;
//   border-left: solid var(--triangleWidth) transparent;
//   border-right: solid var(--triangleWidth) transparent;
//   z-index: 2;
// }

// .video-container:after {
//   content: "";
//   position: absolute;
//   top: 100%;
//   right: 0%;
//   margin-right: var(--triangleWidthNeg);
//   margin-top: var(--triangleheightNeg);
//   width: 0;
//   height: 0;
//   border-bottom: solid var(--triangleHeight) #fff;
//   border-left: solid var(--triangleWidth) transparent;
//   border-right: solid var(--triangleWidth) transparent;
//   z-index: 2;
// }

.overlay {
  position: absolute;
  width: 100%;
}

.sponsor-logo {
  min-width: 250px;
  max-width: 250px;
  padding: 25px 25px 25px 25px;
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.sponsor-logo-img {
  width: 100%;
  line-height: 250px;
}

.hexagon {
  overflow: hidden;
  visibility: hidden;
  -webkit-transform: rotate(120deg);
  -moz-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  -o-transform: rotate(120deg);
  transform: rotate(120deg);
  cursor: pointer;
}
.hexagon-in1 {
  overflow: hidden;
  width: 100%;
  height: 100%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}
.hexagon-in2 {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
  visibility: visible;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

.hexagon-image-crew {
  background-image: url("../../public/img/services/crew_v.jpg");
}
.hexagon-image-academic {
  background-image: url("../../public/img/services/academic.jpg");
}
.hexagon-image-first-rov {
  background-image: url("../../public/img/services/first_rov.png");
}
.hexagon-image-store {
  background-image: url("../../public/img/services/crew_v.jpg");
}

.hexagon2 {
  width: 120%;
  height: 650px;

  margin: auto;
}

.breaker {
  width: 100px;
  border-top: 5px solid #00264a;
  margin: auto;
  margin-top: -5px;
  margin-bottom: 20px;
}
.sponsor-logo .tooltip-inner {
  background-color: #f2f2f2;
  color: black;
}
.bs-tooltip-top .arrow::before {
  border-top-color: #f2f2f2 !important;
}
.what-we-do-icon {
  margin: auto;
  max-height: 100px;
}

.eliptical-gray {
  background-color: #f2f2f2;
  -moz-border-radius: 150% / 35%;
  -webkit-border-radius: 150% / 35%;
  border-radius: 150% / 35%;
  padding: 60px;
  // -webkit-box-shadow: inset 0px 0px 8px 0px rgba(0, 0, 0, 0.58);
  // -moz-box-shadow: inset 0px 0px 8px 0px rgba(0, 0, 0, 0.58);
  // box-shadow: inset 0px 0px 8px 0px rgba(0, 0, 0, 0.58);
}

.what-we-do-cards {
  min-width: 300px;
  max-width: 300px;
  height: 320px;
  padding: 25px 25px 25px 25px;
  display: inline-block;
  overflow: hidden;
  background-color: #fff;
  border-radius: 10px;
  margin: 10px;
}

.what-we-do-cards .header {
  margin: auto;
  font-weight: bolder;
  padding-top: 20px;
  padding-bottom: 10px;
  color: #00264a;
  font-size: 140%;
}

.what-we-do-cards .description {
  color: #7a7575;
  font-size: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  position: relative;
  // left: -18px;
  // width: 118%;
}

.main-topics-container {
  margin: auto;
  width: 80%;
  margin-top: 50px;
}

.shift-up {
  margin-top: -150px;
}

.back-text {
  position: relative;
  opacity: 0.05;
  top: 45px;
  z-index: 0;
  font-size: 70px;
  font-weight: 700;
}

.down-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
}

@-webkit-keyframes bounce {
  0% {
    transform: rotate(90deg) scale(1, 1) translate(0px, 0px);
  }

  30% {
    transform: rotate(90deg) scale(0.8, 1) translate(5px, 0px);
  }

  75% {
    transform: rotate(90deg) scale(1.1, 1) translate(-15px, 0px);
  }

  100% {
    transform: rotate(90deg) scale(1, 1) translate(0px, 0px);
  }
}

.bounce {
  text-align: center;
  position: relative;
  top: 20px;
  margin: 0 auto;
  width: 50px;
  -webkit-animation: bounce 1.5s infinite;
  color: rgba(255, 255, 255, 0.4) !important;
  font-size: 200%;
  font-weight: bold;
  z-index: 6;
  cursor: pointer;
  margin-top: -15px;
}

.bounce a {
  color: white;
}
.bounce a:hover {
  color: rgb(219, 209, 209);
}

.contact-us-home-button {
  margin: auto;
  margin: 40px;
  z-index: 7;
}

@media screen and (max-width: 1150px) {
  .newsColumn {
    width: 50%;
  }
}

@media screen and (max-width: 900px) {
  .mid-screen-text {
    top: 50%;
  }

  .what-we-do {
    font-size: 21px;
    line-height: 21px;
    margin-top: 5px;
  }

  .who-we-are {
    font-size: 17px;
  }
}

@media screen and (max-width: 700px) {
  .myBtnContainer .col {
    flex-basis: unset !important;
  }

  .back-text {
    top: 40px;
    font-size: 50px;
  }
  .newsColumn {
    width: 100%;
  }
  .myBtnContainer .btn {
    width: 100% !important;
    margin-bottom: 10px;
  }
  .shift-up {
    margin-top: 0px;
  }
  .eliptical-gray {
    -moz-border-radius: 170% / 10%;
    -webkit-border-radius: 170% / 10%;
    border-radius: 170% / 10%;
    padding: 0px;
    padding-top: 70px;
    padding-bottom: 70px;
  }
}

@media screen and (max-width: 500px) {
  .large-hexa-container .col {
    flex-basis: inherit;
  }
  .hexagon2 {
    width: 80%;
    height: 400px;
    margin: auto !important;
  }
  .newsColumn {
    width: 100%;
  }
  .myBtnContainer .btn {
    width: 100% !important;
    margin-bottom: 10px;
  }

  .what-we-do-cards {
    margin: 10px;
  }
  .contact-us-home-button {
    font-size: 13px !important;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
